<template lang="pug">
  .d-inline-block
    v-dialog(v-model="isModalVisible" width='600px')
      v-card(data-cy="detail-plan-selected")
        title-bar(dark) {{planName}} Plan
          template(slot="extras")
            v-btn.close-icon(icon @click="hide")
              v-icon close
        v-card-text
          h3.plan-selected {{planName}} subscription selected. Choose a billing option:
          v-radio-group(v-model="checked")
            v-radio(
              :value="true"
            )
              template(slot="label")
                h3.radio-text {{planName}} billed {{ isMonthlyBilling ? 'monthly' : 'annually '}}
            p.recurrent-text ${{price}} {{ isMonthlyBilling ? 'charged monthly' : 'charged annually' }}
          v-layout.box(row)
            v-flex(xs6)
              h3.total-label Total
              h2.total-text ${{price}}
            v-flex(xs6)
              v-layout(row justify-end)
                v-btn(color="primary" @click="goCheckout") Proceed to checkout
          v-layout(row justify-start)
            v-btn.back.mt-4(data-cy="cancel-payment" flat @click="backToPlans")
              v-icon keyboard_arrow_left
              | Back to subscription selection
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import { formatDate } from '@/Core/filters/dates';
import { ADDON_PLANS } from '@/Core/config/addons';

export default {
  name: 'AddPayment',
  filters: {
    formatDate,
  },
  components: {
    TitleBar,
  },
  props: {
    dialog: false,
  },
  methods: {
   ...mapMutations('payment', ['setShowAddPayment', 'setShowPageHosted', 'setShowDetailPlanSelected', 'setShowPlans']),
    hide(){
      this.isModalVisible = false;
    },
    backToPlans(){
      this.hide();
      this.setShowPlans(true);
    },
    addPayment(){
      this.hide();
      this.setShowPageHosted(true);
    },
    goCheckout(){
      this.hide();
      this.setShowAddPayment(true);
    }
  },
  computed: {
    ...mapState('payment', ['addonId', 'isMonthlyBilling']),
    ...mapGetters('payment', ['planName']),
    isModalVisible: {
      get() {
        return this.dialog;
      },
      set(value) {
        return this.setShowDetailPlanSelected(value);
      },
    },
    price(){
      if(!this.addonId) return 0;
      return this.plans.find(p => p.id === this.addonId).price;
    },
  },
  data(){
    return {
      checked: true,
      plans: ADDON_PLANS
    }
  }
};
</script>
<style lang="scss" scoped>
  .box {
    display: flex;
    flex-direction: row;
    border: 1px solid #979797;
    margin-bottom: 5px;
    padding: 25px;
  }

  .plan-selected {
    margin-bottom: 50px;
    margin-top: 10px;
  }

  .radio-text {
    font-size: 16px;
    color: black;
  }

  .recurrent-text{
    margin-top: -10px;
    font-size: 14px;
    margin-left: 30px;
  }

  .total-label {
    font-weight: 400;
    font-size: 15px;
  }

  .total-text {
    font-weight: 500;
  }

  .close-icon {
    color: white;
  }

  .back {
    color: #86868e !important;
    box-shadow: 2px 2px 4px #888888 !important;
    padding: 4px;
    font-size: 15px !important;
    width: 320px !important;
  }
</style>
